<template>
  <modal
    v-model="isActive"
    :append-to-body="true"
    :title="$t('NUMBER_SELECT_AFFILIATE')"
    :footer="false"
    @hide="$emit('cancel')"
  >
    <form
      role="form"
      class="form-horizontal"
      :name="formName"
      novalidate
    >
      <fieldset>
        <div class="container-fluid">
          <div class="form-group">
            <label
              v-t="'NUMBER_SELECT_AFFILIATE_NUMBER'"
              class="col-sm-2 col-md-3 control-label"
            />
            <div class="col-sm-9 form-control-static text-bold">
              {{ selectedNumber.phoneNumber }}
            </div>
          </div>

          <div class="form-group">
            <label
              v-t="'NUMBER_SELECT_AFFILIATE_PUBLISHER'"
              class="col-sm-2 col-md-3 control-label"
            />
            <div class="col-sm-6 col-md-5">
              <SearchableDropdown
                v-model="selectedAffiliate"
                :config="affiliatesListConfig"
              />
            </div>
          </div>

          <div class="form-group text-align-right">
            <PrimaryButton
              :do-on-click="_onSubmit"
            >
              <span v-t="'NUMBER_SELECT_AFFILIATE_ADD_PUBLISHER'" />
            </PrimaryButton>
          </div>
        </div>
      </fieldset>
    </form>
  </modal>
</template>

<script>

import { defineComponent } from 'vue';
import sharedMessages from '@/core/locales';
import messages from '../../locales';
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown.vue';
import PrimaryButton from '@/core/components/PrimaryButton/index.vue';

export default defineComponent({
  components: {
    SearchableDropdown,
    PrimaryButton,
  },
  emits: ['cancel', 'submit'],
  props: {
    selectedNumber: {
      type: Object,
      required: true,
    },
    affiliatesList: {
      type: Array,
      required: true,
    },
    formName: { // selectAffiliateForm
      type: String,
      required: false,
    },
    onSubmit: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      selectedAffiliate: null,
      isLoading: false,
      isActive: true,
    };
  },
  computed: {
    affiliatesListConfig() {
      return {
        placeholder: this.$t('NUMBER_SELECT_AFFILIATE_SEARCH_PUBLISHER'),
        options: this.affiliatesList
          .map(item => ({
            original: item,
            label: item.name,
            value: item.id,
          })),
      };
    },
  },
  methods: {
    _onSubmit() {
      const args = {
        affiliateId: this.selectedAffiliate.original.id,
        numberId: this.selectedNumber.id,
      };

      const res = this.$props.onSubmit?.(args);
      this.$emit('submit', args);
      return res;
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  },
});

</script>
